import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { TradableToListItemComponent } from "./tradable-to-list-item/tradable-to-list-item.component";
import { TradableToWalletComponent } from "./tradable-to-wallet/tradable-to-wallet.component";
import { FilterModule } from "../filters/filter.module";
import { WalletSelectionModalComponent } from "./tradable-to-wallet/wallet-selection-modal/wallet-selection-modal.component";
import { TradableListEmptyComponent } from "./tradable-to-list-item/tradable-list-empty-state/tradable-list-empty.component";
import { TilesModule } from "@modules/main/components/tiles/tiles.module";
import { TradableChartModule } from "@modules/main/components/tradable-chart/tradable-chart.module";
import { CarouselSliderModule } from "@modules/shared/carousel-module/carousel-slider.module";
import { BannerCardModule } from "@modules/shared/banner-card-module/banner-card.module";
import { RealSecuritiesBannerComponent } from "@modules/core/components/real-securities-banner/real-securities-banner.component";

const components = [
	TradableToListItemComponent,
	TradableToWalletComponent,
	TradableListEmptyComponent,
	WalletSelectionModalComponent
];

@NgModule({
	imports: [
		CoreModule,
		FilterModule,
		TilesModule,
		TradableChartModule,
		CarouselSliderModule,
		BannerCardModule,
		RealSecuritiesBannerComponent
	],
	declarations: [...components],
	exports: [...components]
})
export class TradableToViewModule {}
